<app-cookie-manager [dir]="direction" ></app-cookie-manager>
